import HeroSection from './components/HeroSection';
import FeaturedComics from './components/FeaturedComics';
import CategoryGrid from './components/CategoryGrid';
import LatestUpdates from './components/LatestUpdates';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import SEOHead from '@/components/base/SEOHead';
import ScrollToTop from '@/components/base/ScrollToTop';
import { Link } from 'react-router-dom';

const homepageSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: '动漫之家',
  url: 'https://dongmanzhijia.com',
  description: '动漫之家专注无删减韩国漫画下拉式呈现，韩漫在线免费阅读热门新作实时更新，画质高清、加载流畅，为您打造优质阅读平台。',
  potentialAction: {
    '@type': 'SearchAction',
    target: 'https://dongmanzhijia.com/search?q={search_term_string}',
    'query-input': 'required name=search_term_string',
  },
  inLanguage: 'zh-CN',
};

const orgSchema = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: '动漫之家',
  url: 'https://dongmanzhijia.com',
  description: '韩国漫画无删减免费阅读平台',
  sameAs: ['https://weibo.com/dongmanzhijia', 'https://weixin.qq.com/dongmanzhijia'],
};

export default function Home() {
  return (
    <>
      <SEOHead
        title="韩国漫画无删减下拉式韩漫在线免费阅读"
        description="动漫之家专注无删减韩国漫画下拉式呈现，韩漫在线免费阅读热门新作实时更新，画质高清、加载流畅，为您打造优质阅读平台。涵盖恋爱、奇幻、动作、悬疑等丰富分类，每日更新。"
        keywords="韩国漫画,无删减漫画,下拉式漫画,韩漫在线免费阅读,动漫之家,优质阅读平台"
        canonicalUrl="https://dongmanzhijia.com/"
        ogTitle="韩国漫画-无删减漫画下拉式-韩漫在线免费阅读-动漫之家"
        ogDescription="动漫之家专注无删减韩国漫画下拉式呈现，韩漫在线免费阅读热门新作实时更新。"
        schemaData={[orgSchema, homepageSchema]}
      />
      <ScrollToTop />
      <div className="min-h-screen bg-background-50">
        <Navbar />
        <main>
          <HeroSection />
          <FeaturedComics />
          <CategoryGrid />
          <LatestUpdates />

          <section className="py-14 md:py-20 bg-background-900" aria-labelledby="cta-heading">
            <div className="max-w-3xl mx-auto text-center px-4">
              <h2 id="cta-heading" className="text-2xl md:text-4xl font-heading font-bold text-white mb-4">
                还在等什么？立即开启你的漫画之旅
              </h2>
              <p className="text-sm md:text-base text-background-300 mb-8 leading-relaxed">
                2000+ 部精选韩国漫画，每日更新，高清下拉式阅读体验，全部免费。加入 500 万读者的选择！
              </p>
              <Link
                to="/category"
                className="inline-flex items-center gap-2 px-8 py-3 rounded-full bg-accent-500 text-white font-semibold text-sm hover:bg-accent-600 transition-colors whitespace-nowrap cursor-pointer"
              >
                免费开始阅读 <i className="ri-arrow-right-line"></i>
              </Link>
            </div>
          </section>
        </main>
        <Footer />
      </div>
    </>
  );
}